import { GET } from './apiHandler';
import { API_BASE_URL } from 'src/globals';
import { FETCH_AUTH_SETTINGS } from './routes';

export const fetchAuthSettings = () => {
  return GET(`${API_BASE_URL}${FETCH_AUTH_SETTINGS}`);
};
